<rl-dialog-window (onClose)="close()" [title]="warnTitle ? warnTitle : 'winDialog.warn'">
    <p class="no-margin normal-text">
    	<span class="label-warning large-text" *ngIf="warnTitle == 'explorer.notSupported.msg.header'">
    		<i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
    	</span>
    	{{message | translate}}
    </p>
</rl-dialog-window>